export const LOADER_FACTORSCRITERIA = "LOADER_FACTORSCRITERIA";
export const LOADER_FACTORCRITERION = "LOADER_FACTORCRITERION";
export const SAVE_LOADER_FACTORCRITERION = "SAVE_LOADER_FACTORCRITERION";
export const GET_FACTORSCRITERIA = "GET_FACTORSCRITERIA";
export const GET_FACTORCRITERION = "GET_FACTORCRITERION";
export const FORM_FACTORSCRITERIA_FAIL = "FORM_FACTORSCRITERIA_FAIL";
export const FACTORSCRITERIA_FAIL = "FACTORSCRITERIA_FAIL";
export const FACTORCRITERION_FAIL = "FACTORCRITERION_FAIL";